import React, { useContext } from "react";
import { LanguageContext } from "../languages/languageContext";
import { Link } from "react-router-dom";

interface ProjectItemProps {
  project: IProject;
}

const ProjectItem: React.FC<ProjectItemProps> = ({ project }) => {
  const language_id = useContext(LanguageContext).id;

  const truncateStringAtWhitespace = (str, lim, ending = "...") => {
    if (str.length <= lim) return str;
    const lastSpace = str.slice(0, lim - ending.length + 1).lastIndexOf(" ");
    return (
      str.slice(0, lastSpace > 0 ? lastSpace : lim - ending.length) + ending
    );
  };

  const descriptionLength = project
    ? project.description[language_id as keyof IProject["description"]].length
    : 0;

  return (
    <Link
      to={`/projects/${project.slug[language_id as keyof IProject["title"]]}`}
    >
      <article className="group mb-5 p-0 transition duration-150 sm:p-4 sm:hover:bg-gray-200">
        <h3 className="mb-3 flex flex-col-reverse items-start gap-0">
          <span className="text-3xl text-gray-700">
            {project.title[language_id as keyof IProject["title"]]}
          </span>
        </h3>

        <div className=" flex flex-col items-start gap-2 sm:flex-row md:flex-col lg:flex-row">
          <img
            className="z-10 rounded-lg border transition-all duration-500 ease-in-out group-hover:opacity-0 sm:w-[300px] md:w-full lg:w-[400px]"
            src={project.coverImage}
            alt=""
          />
          <img
            className="absolute rounded-lg border sm:w-[300px] md:w-full lg:w-[400px]"
            src={project.coverImage2}
            alt=""
          />
          <div className="text-gray-600 lg:pl-5">
            <p className="mb-3 text-lg text-gray-600">
              {descriptionLength > 200
                ? truncateStringAtWhitespace(
                    project.description[
                      language_id as keyof IProject["description"]
                    ],
                    200
                  )
                : project.description[
                    language_id as keyof IProject["description"]
                  ]}
            </p>
            <div className="flex flex-wrap gap-1">
              {project.stack.map((stack, idx) => (
                <span
                  key={idx}
                  className={`flex items-center gap-1  bg-gray-700 py-0 px-1 font-['Unica_One'] text-base text-white`}
                >
                  <stack.Icon />
                  <span>{stack.name.toUpperCase()}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default ProjectItem;
